import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import CircularProgress from '@material-ui/core/CircularProgress';
import AlertDialog from '../parts/AlertDialog';
import { classColours } from '../../helpers';
const colours = classColours();

const styles = theme => ({
  card: {
    width: '100%',
    color: '#ffffff',
  },
  cardInner: {
    padding: 16,
    minHeight: 154,
  },
  cardHeading: {
    fontSize: 24,
  },
  cardButton: {
    color: '#ffffff',
    marginTop: 10,
  },
  textCenter: {
    textAlign: 'center',
    padding: '20px 20px 0',
    minHeight: 80,
  },
});

const mapStateToProps = state => {
  return {
    selectedPupil: state.selectedPupil,
  };
};

class ClassesPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isLoaded: false,
      data: [],
      isAlertDialogOpen: false,
      alertDialogTitle: '',
      alertDialogContent: '',
    };

    this.axiosCancel = null;

    this.onShowAllTeachers = this.onShowAllTeachers.bind(this);
  }

  componentDidMount() {
    this.reloadData();
  }

  componentWillUnmount() {
    if (this.axiosCancel) {
      this.axiosCancel();
    }
  }

  onShowAllTeachers(classData) {
    const {
      t,
    } = this.props;

    this.setState({
      isAlertDialogOpen: true,
      alertDialogTitle: t('Teachers') +  ' - ' + classData.name,
      alertDialogContent: (
        <React.Fragment>
          <List>
            {classData.teachers.length && classData.teachers.map((teacher) => {
              return (
                <ListItem key={teacher}>
                  <ListItemText primary={teacher} />
                </ListItem>
              )
            })}
          </List>
        </React.Fragment>
      ),
    })
  }

  reloadData(date) {
    const {
      selectedPupil,
    } = this.props;

    this.setState({
      isLoading: true,
    });

    axios
      .get(
        `${window.apiUrl}/classes/${selectedPupil.id}`,
        {
          cancelToken: new axios.CancelToken((c) => { this.axiosCancel = c }),
        }
      )
      .then((response) => {
        if (response.data.success) {
          this.setState({
            data: response.data.data,
          });
        }

        this.setState({
          isLoading: false,
          isLoaded: true,
        });
      })
      .catch((thrown) => {});
  }

  renderClass(classData, index) {
    const {
      classes,
      t,
    } = this.props;

    const backgroundColorIndex = index % colours.length;
    const backgroundColor = colours[backgroundColorIndex];

    return (
      <Paper
        className={classes.card}
        style={{ backgroundColor }}
      >
        <div className={classes.cardInner}>
          <Typography className={classes.cardHeading}>
            {classData.name}
          </Typography>
          {classData.subject && (
            <Typography>
              {classData.subject}
            </Typography>
          )}
          {classData.room && (
            <Typography>
              {classData.room}
            </Typography>
          )}
          {classData.teacher && (
            <Typography>
              {classData.teacher}
            </Typography>
          )}
          {classData.teachers.length > 0 && (
            <Button
              onClick={this.onShowAllTeachers.bind(this, classData)}
              color="primary"
              className={`show-all-teachers-button ${classes.cardButton}`}
            >
              {t('Show all teachers')}
            </Button>
          )}
        </div>
      </Paper>
    );
  }

  render() {
    const {
      classes,
      t,
    } = this.props;
    const {
      data,
      isLoading,
      isLoaded,
      isAlertDialogOpen,
      alertDialogTitle,
      alertDialogContent,
    } = this.state;

    return (
      <div className="classes-page">
        {isLoading && !isLoaded && (
          <div className={classes.textCenter}>
            <CircularProgress />
          </div>
        )}
        {isLoaded && (
          <Grid container spacing={2}>
            {data.length === 0 && (
              <Grid item xs={12} className={classes.textCenter}>
                {t('No classes found')}
              </Grid>
            )}
            {data.length > 0 && data.map((classData, index) => {
              return (
                <Grid
                  key={classData.id}
                  item
                  xs={12}
                  sm={6}
                  md={4}
                >
                  {this.renderClass(classData, index)}
                </Grid>
              )
            })}
          </Grid>
        )}
        <AlertDialog
          useSuspense={false}
          title={alertDialogTitle}
          isOpen={isAlertDialogOpen}
          onClose={() => this.setState({
            isAlertDialogOpen: false,
          })}
        >
          {alertDialogContent}
        </AlertDialog>
      </div>
    );
  }
}

export default connect(mapStateToProps)(
  withStyles(styles)(withTranslation()(ClassesPage))
);
